import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

import { AccountVerificationModalControl, LotteryErrorModal } from '#components'

export const useLotteryCheckoutError = (
  lotteryId: LotteryId,
  backroute: string,
  onConfirm?: () => void,
) => {
  const localePath = useLocalePath()
  const { log } = useDatadog()
  const { openModal, registerModal } = useModal()

  const error = ref<unknown>(null)

  const openAccountVerificationModal = () =>
    openModal({
      component: AccountVerificationModalControl,
      props: {
        redirect: localePath(`/checkout?p=${lotteryId.toLowerCase()}&backroute=${backroute}`),
      },
    })

  const handleError = (caught: unknown) => {
    if (isSpecificGraphQLError(caught, { matchMessage: 'error.verification.status' })) {
      openAccountVerificationModal()
      return
    }
    if (isSpecificGraphQLError(caught, { matchMessage: 'validation.playslip.duplicate' })) {
      log('warn', {
        appendPlayerInfo: true,
        component: 'lotteryCheckoutError.ts',
        message: 'Duplicate play slip replay attempt',
        messageContext: { backroute, lotteryId },
      })
    }
    error.value = caught
  }

  registerModal({
    component: LotteryErrorModal,
    onCancel: () => (error.value = null),
    onConfirm,
    props: () => ({ error: error.value ?? null }),
    when: () => !!error.value,
  })

  return { handleError, openAccountVerificationModal }
}
